import Model from '/lib/model'

export default \
class TicketmasterVenue extends Model
  @className: 'TicketmasterVenue'
  constructor: ->
    super arguments...
    @id               = null
    @name             = null
